import { Conversation, Result } from '@/classes'
import { fetchAPI } from '@/utils/useAPI'
import { useStore } from '@/utils/useStore'

import { conversationMessageRemoveAPI } from '@/api/conversations'

export default defineStore('conversations-messages', () => {
  const { getItem, getItemMulti, getItems, setItem, deleteItem } = useStore('conversation-message', {
    indexes: [ 'conversation' ]
  })

  const remove = async (messageId: string) => {
    const message: any = getItem(messageId)

    deleteItem(messageId)

    if (!message.isFailed) await conversationMessageRemoveAPI(messageId)
  
    return 
  }

  return {
    setItem, deleteItem, remove,
    getItems, getItem, fetch, getItemMulti
  }
})